import styled from "styled-components/macro";

export const ReportStyles = styled.div`
  /* padding-bottom: 1em; */
  float: none;

  .recharts-wrapper,
  .recharts-surface {
    width: calc(100%) !important;
  } /** leaving in for future implementations */

  /* .recharts-legend-wrapper,
  .recharts-default-legend {
    left: 0px !important;
    top: 0px !important;
  } */

  .reportBody {
    padding-right: 1%;
    padding-left: 1%;
  }

  .main-div {
    display: initial;
  }
  .print-div {
    display: none;
  }

  .chartParent {
    display: flex;
    margin-left: 2em;
    margin-right: 2em;
    align-content: center;
  }

  .printerFriendlyBox {
    height: 400px !important;
  }

  @media print {
    @page {
      size: portrait;
    }
    .secondHeader {
      height: 86px !important;
    }
    .other-header {
      break-before: always;
    }

    .main-div {
      display: none;
    }
    .print-div {
      display: initial;
    }
  }
`;
